import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { Warehouse } from '../../models/warehouse';
import {
  WarehouseActivityItem,
  WarehouseOccupancy,
  WarehouseOccupancySummary,
  WarehouseReconciliation,
} from '../../models/warehouse-occupancy';

@Injectable({
  providedIn: 'root',
})
export class WarehouseService {
  currentDomain = environment.currentApiHostname;
  apiUrl = `https://${this.currentDomain}/api/general`;

  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/warehouses?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Warehouse>>(
      this.apiUrl + `/warehouses/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
        `/exports/warehouses/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Warehouse>(
      this.apiUrl + `/warehouses/${uuid}`,
      options
    );
  }

  store(payload: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Warehouse>(
      this.apiUrl + `/warehouses`,
      payload,
      options
    );
  }

  update(payload: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Warehouse>(
      this.apiUrl + `/warehouses/update/${uuid}`,
      payload,
      options
    );
  }

  occupancy(warehouseUuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<WarehouseOccupancy>(
      this.apiUrl + `/warehouses/occupancy/${warehouseUuid}`,
      options
    );
  }

  occupancySummary() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<WarehouseOccupancySummary>>(
      this.apiUrl + `/warehouses/index/occupancy`,
      options
    );
  }

  activity(warehouseUuid: string, limit: number = 15) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<WarehouseActivityItem>>(
      this.apiUrl + `/warehouses/activity/${warehouseUuid}?limit=${limit}`,
      options
    );
  }

  reconciliation(warehouseUuid: string, from: number, to: number) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<WarehouseReconciliation>(
      this.apiUrl + `/warehouses/reconciliation/${warehouseUuid}/${from}/${to}`,
      options
    );
  }
}
